import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import StackLobePiercingImage from '../../Assets/Piercing Services/stack lobe piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function StackLobePiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
            <title>Stack Lobe Piercing Dubai, UAE </title>
            <meta
                name="description"
                content="Stack Lobe Piercing Dubai, UAE for creating a layered ear look with carefully placed piercings and quality jewellery."
            />             
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Stack Lobe Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Stack Lobe Piercing 100-200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={StackLobePiercingImage} alt="Stack Lobe Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Stack Lobe Piercing</h3>

          <p>
            Transform your ear styling with our professional stack lobe piercing services in the UAE, available at an affordable price range of 100–200 AED. Stack lobe piercing is a bold and trendy choice that involves multiple lobe piercings placed closely together to create a stylish, layered statement look. Perfect for those who love modern ear aesthetics, this piercing style allows you to mix and match studs, hoops, and mini jewelry pieces for a unique and personalized appearance. Whether you want a subtle stacked arrangement or a more eye-catching design, our expert specialists ensure precise placement that enhances your overall style.
          </p>

          <p>
            We are committed to delivering safe, hygienic, and high-quality piercing services using sterile, single-use equipment and advanced techniques. Our certified professionals follow strict hygiene protocols to ensure a clean and infection-free experience for every client. Each stack lobe piercing is performed with accuracy and care, minimizing discomfort while ensuring a smooth and efficient procedure. Our goal is to provide a quick, comfortable, and stress-free experience that meets your expectations and leaves you feeling confident.
          </p>

          <p>
            Stack lobe piercing is ideal for individuals who want to create a bold and fashionable ear stack without moving into cartilage piercings. It is suitable for both teens and adults who are looking to elevate their ear styling with a modern and creative touch. The procedure is simple and typically completed within a short time, even when multiple piercings are involved. Our specialists use techniques designed to reduce pain and promote faster healing, ensuring that you can enjoy your new look with minimal downtime.
          </p>

          <p>
            We also offer high-quality, hypoallergenic starter earrings that are safe for sensitive skin, helping to prevent irritation and allergic reactions. Our team provides personalized consultation to help you plan your stack lobe design, including spacing, alignment, and jewelry options. Whether you prefer a tight cluster for a bold statement or a slightly spaced stack for a balanced look, we tailor the piercing to suit your style and comfort.
          </p>

          <p>
            Our clean and welcoming environment ensures that every client feels relaxed and at ease throughout the process. We understand that multiple piercings can feel overwhelming, which is why our friendly professionals are always available to guide you and provide reassurance. From the initial consultation to the final result, we ensure that every step is handled with professionalism and attention to detail.
          </p>

          <p>
            Aftercare is especially important for stack lobe piercings, and we provide detailed instructions to help you care for each piercing properly. Our team will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation during the healing period. With proper care, your stack lobe piercings will heal effectively and become a standout feature of your style.
          </p>

          <p>
            Our stack lobe piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that suits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted stack lobe piercing services in the UAE for a safe, stylish, and professional experience. With skilled specialists, sterile procedures, and a focus on customer satisfaction, we help you achieve a bold and fashionable statement look effortlessly. Book your stack lobe piercing appointment today and redefine your ear styling with confidence and creativity.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Stack Lobe Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default StackLobePiercing;